import React, { useState, useEffect } from 'react';
import { Alert, Button } from 'antd';
import { BulbOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { ANNOUNCEMENTS, Announcement } from '../config/announcements';

const STORAGE_KEY = 'shades_seen_announcements';

const getSeenAnnouncements = (): string[] => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

const markAsSeen = (id: string) => {
  const seen = getSeenAnnouncements();
  if (!seen.includes(id)) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...seen, id]));
  }
};

export const AnnouncementBanner: React.FC = () => {
  const navigate = useNavigate();
  const [currentAnnouncement, setCurrentAnnouncement] = useState<Announcement | null>(null);

  useEffect(() => {
    const seen = getSeenAnnouncements();
    // Find first unseen announcement (newest first)
    const unseen = [...ANNOUNCEMENTS].reverse().find(a => !seen.includes(a.id));
    setCurrentAnnouncement(unseen || null);
  }, []);

  const handleDismiss = () => {
    if (currentAnnouncement) {
      markAsSeen(currentAnnouncement.id);
      // Check for next unseen announcement
      const seen = getSeenAnnouncements();
      const next = [...ANNOUNCEMENTS].reverse().find(a => !seen.includes(a.id));
      setCurrentAnnouncement(next || null);
    }
  };

  const handleNavigate = () => {
    if (currentAnnouncement?.linkPath) {
      markAsSeen(currentAnnouncement.id);
      navigate(currentAnnouncement.linkPath);
      setCurrentAnnouncement(null);
    }
  };

  if (!currentAnnouncement) return null;

  return (
    <Alert
      type={currentAnnouncement.type}
      showIcon
      icon={<BulbOutlined />}
      message={currentAnnouncement.title}
      description={
        <div>
          <div>{currentAnnouncement.description}</div>
          {currentAnnouncement.linkPath && (
            <Button
              type="link"
              size="small"
              onClick={handleNavigate}
              style={{ padding: 0, marginTop: 8 }}
            >
              {currentAnnouncement.linkText || 'Learn more'} →
            </Button>
          )}
        </div>
      }
      closable
      onClose={handleDismiss}
      style={{ marginBottom: 16 }}
    />
  );
};
